(() => {
  const initialiseEarlyBloomPrices = (scope = document) => {
    scope.querySelectorAll('[data-early-bloom-price]').forEach((price) => {
      if (price.dataset.earlyBloomReady === 'true') return;

      const cutoff = Date.parse(price.dataset.earlyBloomCutoff || '');
      if (Number.isNaN(cutoff)) return;

      const updatePrice = () => {
        const isActive = Date.now() < cutoff;

        price.querySelectorAll('[data-early-bloom-active]').forEach((element) => {
          element.hidden = !isActive;
        });
        price.querySelectorAll('[data-early-bloom-expired]').forEach((element) => {
          element.hidden = isActive;
        });

        const ticket = price.closest('.a4y-event__ticket');
        ticket?.querySelectorAll('[data-early-bloom-active]').forEach((element) => {
          element.hidden = !isActive;
        });
        ticket?.querySelectorAll('[data-early-bloom-expired]').forEach((element) => {
          element.hidden = isActive;
        });

        const eventRoot = price.closest('.a4y-event');
        eventRoot?.querySelectorAll('[data-early-bloom-note]').forEach((note) => {
          note.hidden = !isActive;
        });

        if (isActive) {
          window.setTimeout(updatePrice, Math.min(cutoff - Date.now() + 1000, 2147483647));
        }
      };

      updatePrice();
      price.dataset.earlyBloomReady = 'true';
    });

    scope.querySelectorAll('[data-early-bloom-note]').forEach((note) => {
      const cutoff = Date.parse(note.dataset.earlyBloomCutoff || '');
      if (!Number.isNaN(cutoff) && Date.now() >= cutoff) note.hidden = true;
    });
  };

  const initialiseEventStickyButtons = (scope = document) => {
    scope.querySelectorAll('.a4y-event').forEach((eventRoot) => {
      if (eventRoot.dataset.stickyReady === 'true') return;

      const heroButton = eventRoot.querySelector('.a4y-event__hero .a4y-event__button');
      const stickyButton = eventRoot.querySelector('.a4y-event__sticky');

      if (!heroButton || !stickyButton || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          stickyButton.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0.15 }
      );

      observer.observe(heroButton);
      eventRoot.dataset.stickyReady = 'true';
    });
  };

  const initialiseEventVideoCovers = (scope = document) => {
    scope.querySelectorAll('[data-a4y-event-video-play]').forEach((button) => {
      if (button.dataset.videoCoverReady === 'true') return;

      const video = button.closest('.a4y-event__video')?.querySelector('video');
      if (!video) return;

      const hideCover = () => {
        button.hidden = true;
      };

      button.addEventListener('click', () => {
        hideCover();
        const playRequest = video.play();

        if (playRequest?.catch) {
          playRequest.catch(() => {
            button.hidden = false;
          });
        }
      });

      video.addEventListener('play', hideCover);
      video.addEventListener('ended', () => {
        video.load();
        button.hidden = false;
      });

      button.hidden = false;
      button.dataset.videoCoverReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseEarlyBloomPrices();
      initialiseEventStickyButtons();
      initialiseEventVideoCovers();
    });
  } else {
    initialiseEarlyBloomPrices();
    initialiseEventStickyButtons();
    initialiseEventVideoCovers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseEarlyBloomPrices(event.target);
    initialiseEventStickyButtons(event.target);
    initialiseEventVideoCovers(event.target);
  });
})();
